import Vue from 'vue'
import App from './App.vue'
import './assets/fonts/DINPro-FONT/index.css'
import config from './config'

Vue.config.productionTip = false

import Vuex from 'vuex'
import VueRouter from 'vue-router'

// CUSTOM IMPORTS
import router from './router.js'
import store from "@/store";

//Vue-Socket.IO
import VueSocketIO from 'vue-socket.io'
Vue.use(new VueSocketIO({
    debug: true,
    connection: config.NODE_HOST,
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    },
}))

function sideScroll(element, direction, speed, distance, step) {
    let scrollAmount = 0;
    var slideTimer = setInterval(function () {
        element.scrollLeft += direction * step;
        scrollAmount += step;
        if (scrollAmount >= distance) {
            window.clearInterval(slideTimer);
        }
    }, speed);
}

Vue.directive('arrowscroll', {
    inserted: function(el){
        var counter = 0;
        var counterLimit = 5;
        addArrowScroll();

        let checkInterval = setInterval(addArrowScroll, 1000);

        function addArrowScroll(){

            var container = el.childNodes[0];
                
            if(container.scrollWidth > el.offsetWidth && counter < counterLimit)
            {
                el.classList.add('arrowscroll');
                var leftArrow = document.createElement('div');
                var rightArrow = document.createElement('div');
                var leftIconNode = document.createElement('i');
                var rightIconNode = document.createElement('i');
                leftArrow.classList.add("arrowscroll__arrow");
                rightArrow.classList.add("arrowscroll__arrow");
                rightArrow.classList.add("arrowscroll__arrow--right");
                leftIconNode.classList.add("fas", "fa-chevron-left");
                rightIconNode.classList.add("fas", "fa-chevron-right");
                leftArrow.appendChild(leftIconNode);
                rightArrow.appendChild(rightIconNode);
    
                let childElementCompStyle;
                let animWidth = container.offsetWidth - 60;

                if(container.childNodes[0] !== undefined){
                    childElementCompStyle = window.getComputedStyle(container.childNodes[0]);
                    animWidth = container.childNodes[0].offsetWidth + parseInt(childElementCompStyle.getPropertyValue('margin-left').replace(/\D/g,'')) + parseInt(childElementCompStyle.getPropertyValue('margin-right').replace(/\D/g,''));
                }
    
                leftArrow.addEventListener('click', () => {
                    sideScroll(container, -1, 10, animWidth, 20);
                });
                rightArrow.addEventListener('click', () => {
                    sideScroll(container, 1, 10, animWidth, 20);
                });
                el.appendChild(leftArrow);
                el.appendChild(rightArrow);

                counter = counterLimit;
            }
            else {
                counter++;
            }

            if(counter >= counterLimit)
                clearInterval(checkInterval);
        }
    },
    componentUpdated: function(el){
        var container = el.childNodes[0];

        function addArrowScroll(){
                        
            if(container.scrollWidth > el.offsetWidth && !el.classList.contains('arrowscroll'))
            {
                el.classList.add('arrowscroll');
                var leftArrow = document.createElement('div');
                var rightArrow = document.createElement('div');
                var leftIconNode = document.createElement('i');
                var rightIconNode = document.createElement('i');
                leftArrow.classList.add("arrowscroll__arrow");
                rightArrow.classList.add("arrowscroll__arrow");
                rightArrow.classList.add("arrowscroll__arrow--right");
                leftIconNode.classList.add("fas", "fa-chevron-left");
                rightIconNode.classList.add("fas", "fa-chevron-right");
                leftArrow.appendChild(leftIconNode);
                rightArrow.appendChild(rightIconNode);
                
                let childElementCompStyle;
                let animWidth = container.offsetWidth - 60;

                if(container.childNodes[0] !== undefined){
                    childElementCompStyle = window.getComputedStyle(container.childNodes[0]);
                    animWidth = container.childNodes[0].offsetWidth + parseInt(childElementCompStyle.getPropertyValue('margin-left').replace(/\D/g,'')) + parseInt(childElementCompStyle.getPropertyValue('margin-right').replace(/\D/g,''));
                }
    
                leftArrow.addEventListener('click', () => {
                    sideScroll(container, -1, 10, animWidth, 20);
                });
                rightArrow.addEventListener('click', () => {
                    sideScroll(container, 1, 10, animWidth, 20);
                });
                el.appendChild(leftArrow);
                el.appendChild(rightArrow);
            }
        }

        if(!el.classList.contains('arrowscroll'))
            addArrowScroll();

        if(container.scrollWidth <= el.offsetWidth && el.classList.contains('arrowscroll')){
            el.classList.remove('arrowscroll')
            var arrowButtons = el.querySelectorAll('div.arrowscroll__arrow');

            Array.prototype.forEach.call(arrowButtons, element => {
                element.remove();
            });
        }

    },
    unbind: function(el){
        let elChildNodes = el.childNodes;
        let leftArrowIndex = -1;
        let rightArrowIndex = -1;
        for(let i=0; i<elChildNodes.length; i++)
        {
            if(elChildNodes[i].classList[0] == "arrowscroll__arrow" && elChildNodes[i].classList[1] == "arrowscroll__arrow--right")
                rightArrowIndex = i;
            else if(elChildNodes[i].classList[0] == "arrowscroll__arrow")
                leftArrowIndex = i;
            if(leftArrowIndex != -1 && rightArrowIndex !=-1)
                break;
        }
        if(elChildNodes[rightArrowIndex])
        {
            elChildNodes[rightArrowIndex].style.display = "none";
            elChildNodes[rightArrowIndex].remove();
        }
        if(elChildNodes[leftArrowIndex])
        {
            elChildNodes[leftArrowIndex].style.display = "none";
            elChildNodes[leftArrowIndex].remove();
        }
    }
});


//Dragscroll for desktop
import VueDragscroll from 'vue-dragscroll'

import moment from 'moment';
moment.locale('ro');
var __months = moment.months().map(function (m) {
    return m.charAt(0).toUpperCase() + m.slice(1)
});
moment.updateLocale('ro', {
    months: __months,

    calendar: {
        lastWeek: 'dddd, DD MMMM, YYYY',
        sameElse: 'DD MMMM, YYYY',
    }
});

Vue.use(require('vue-moment'), {
    moment
});


Vue.use(require('vue-moment'));

Vue.use(VueDragscroll)
Vue.use(VueRouter)
Vue.use(Vuex)

// Vue router skip redundant navigation to current location error
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

import 'jodit/build/jodit.min.css'
import JoditVue from 'jodit-vue'
import './registerServiceWorker'

Vue.use(JoditVue)

new Vue({
    router,
    store: store,
    render: h => h(App),
}).$mount('#app')